import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { EpiService } from '../../services/epi/epi.service';
import { AppData } from '../../types/translations.types';
import { IconComponent } from '../icon/icon.component';
import { StepperOptions } from './types/stepper-old.types';

/**
 * @deprecated use NumberPickerComponent instead
 */
@Component({
	selector: 'cramo-stepper-old',
	templateUrl: './stepper-old.component.html',
	styleUrls: ['./stepper-old.component.scss'],
	imports: [FormsModule, IconComponent],
})
export class StepperOldComponent {
	public appData: Signal<AppData>;
	public decreaseButtonIsEnabled = true;
	public increaseButtonIsEnabled = true;
	public hasBeenTouched = false;
	public error = false;
	public min: number;
	public max: number;
	public value = 0;

	@Input()
	public set stepperOptions(options: StepperOptions) {
		if (options) {
			this.value = options.value;
			this.min = options.min;
			this.max = options.max;
			if (this.value <= this.max) {
				this.error = false;
			} else {
				this.error = true;
			}

			this.checkButtons();
		}
	}

	@Input() public disabled: boolean = false;

	@Input() public showSelectedState = false;

	@Output() public byValueChange: EventEmitter<number> = new EventEmitter();

	constructor(private epiService: EpiService) {
		this.appData = toSignal(this.epiService.appData$, { requireSync: true });
	}

	public increase(): void {
		if (!this.max || this.value < this.max) {
			this.onInputChange(this.value + 1);
		}
	}

	public stripDecimals(event: KeyboardEvent): void {
		if (event.key === '.' || event.key === ',') {
			event.preventDefault();
		}
	}

	public decrease(): void {
		if ((!this.min || this.value > this.min) && this.value > 0) {
			this.onInputChange(this.value - 1);
		}
		if (this.error) {
			this.onInputChange(this.max);
		}
	}

	public onInputChange(value: number): void {
		this.value = value;
		// value should always be inside min/max range
		// in case min property is missing, fall back to > 0
		if (this.value <= this.max && this.value >= this.min && this.value > 0) {
			this.error = false;
			this.emitValue(value);
		} else {
			this.error = true;
		}
		this.checkButtons();
	}

	private checkButtons(): void {
		this.increaseButtonIsEnabled = this.value < this.max;
		this.decreaseButtonIsEnabled = this.value > this.min && this.value !== 0;
	}

	private emitValue(value: number): void {
		this.hasBeenTouched = true;
		this.byValueChange.emit(value);
	}
}
